import { useEffect } from 'react'

import { trackExperimentViewed } from '@mc/track-event'

import { useExperimentCriteria } from './useExperimentCriteria'

export const MONEY_BACK_PRICING_MICROCOPY_FLAG_NAME = 'pen-5222_v1'

export const useTrackPen5222Experiment = () => {
  const validExperimentCriteria = useExperimentCriteria()

  useEffect(() => {
    if (!validExperimentCriteria) return

    trackExperimentViewed(MONEY_BACK_PRICING_MICROCOPY_FLAG_NAME)
  }, [validExperimentCriteria])
}
